<template>
  <div
    class="price-breakdown"
    v-if="member_price !== undefined && memberLevel != 'public' && memberLevel != 'silver'"
  >
    <MoreInfoPopover width="250px">
      <div>= Wholesale: {{CurrencyFormatter(member_price.base_price)}}</div>
      <div>+ Handling: {{CurrencyFormatter(member_price.handling_fee)}}</div>
      <div>+ GST: {{CurrencyFormatter(member_price.gst)}}</div>
      <div><span class="heading">Total: </span>{{CurrencyFormatter(member_price.price)}}</div>
    </MoreInfoPopover>
  </div>
</template>

<script>
import { CurrencyFormatter } from "@/utils";
import { mapState } from "vuex";
import MoreInfoPopover from "@/components/MoreInfoPopover"

export default {
  name: "PriceBreakDown",
  components: {
    MoreInfoPopover
  },
  props: ["member_price"],
  methods: {
    CurrencyFormatter
  },
  computed: {
    ...mapState({
      memberLevel: state => state.auth.memberLevel
    })
  }
};
</script>

<style lang="scss" scoped>
.price-breakdown {
  display: inline-block;
  vertical-align: super;
}

.heading{
  font-weight: bold;
}
</style>
